interface ColumnData {
  id: string;
  label: string;
  order: number;
  isVisible: boolean;
  // Fraction of container width (0 < flex ≤ 1). Absent in pre-feature saves; DataTable falls back to columnDef.size.
  flex?: number;
}

export enum SortDirection {
  ASC = "asc",
  DESC = "desc"
}

export const SORT_BY_PARAM = "sortBy";
export const SORT_DIR_PARAM = "sortDir";
export const GROUP_BY_PARAM = "groupBy";

export type { ColumnData };
